import checkDeliverPrintTickets from 'app/pages/NewPaymentCallback/utils/checkDeliverPrintTickets';
import { BaseXHR } from 'utils/axios';

export const getOrderDetailApi = ({
  lang,
  id,
  idItem,
  otp,
}: {
  lang?: string;
  id: string;
  idItem?: string;
  otp?: string;
}) => {
  const suffix = idItem ? `?idItem=${idItem}` : '';
  const { accessDeliverPrintTicketFromEmailLink } = checkDeliverPrintTickets();
  const params = accessDeliverPrintTicketFromEmailLink
    ? { guest: 1, otp: !!otp ? otp : undefined }
    : { guest: 1, otp: !!otp ? otp : undefined };
  // { guest: 1, otp: 285133 };
  return BaseXHR.$get(
    `sunid/v1/deliver-ticket/tickets/${lang}/${id}` + suffix,
    params,
  );
};
export const downloadPdfApi = (
  id: string,
  isLoading: (load: boolean) => void,
  name?: string,
  otp?: string,
  guest?: string,
  lang?: string,
) => {
  isLoading && isLoading(true);
  BaseXHR.$get(
    `sunid/v1/deliver-ticket/download/${lang}/${id}/${otp}`,
    {
      otp: !!otp ? otp : undefined,
      guest: !!guest ? guest : undefined,
    },
    {
      responseType: 'arraybuffer',
    },
  ).then((res: any) => {
    const blob = new Blob([res.data], {
      type: 'application/pdf',
    });
    try {
      if (name) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = name;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        window.location.href = URL.createObjectURL(blob);
      }
    } catch (error) {
    } finally {
      isLoading && isLoading(false);
    }
  });
};
export const downloadAndViewPdf = (
  id: string,
  setIsLoading: (load: boolean) => void,
  otp?: string,
  guest?: string,
  lang?: string,
) => {
  setIsLoading && setIsLoading(true);
  BaseXHR.$get(
    `sunid/v1/deliver-ticket/download/${lang}/${id}/${otp}`,
    {
      otp: !!otp ? otp : undefined,
      guest: !!guest ? guest : undefined,
    },
    {
      responseType: 'arraybuffer',
    },
  ).then((res: any) => {
    const blob = new Blob([res.data], { type: 'application/pdf' });
    try {
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (error) {
    } finally {
      setIsLoading && setIsLoading(false);
    }
  });
};
export const downloadTicketPdfApi = (
  param:
    | string
    | string[][]
    | Record<string, string>
    | URLSearchParams
    | undefined,
  isLoading?: (load: boolean) => void,
  name?: string,
) => {
  isLoading && isLoading(true);
  const searchParams = new URLSearchParams(param);
  const params = Object.fromEntries(searchParams);
  const { lang, orderId, orderItemId, otp } = params;
  if (!lang || !orderId || !orderItemId) return;
  const urlApi = `sunid/v1/deliver-ticket/download/ticket/${lang}/${orderId}/${otp}/${orderItemId}`;
  BaseXHR.$get(urlApi, undefined, {
    responseType: 'arraybuffer',
  })
    .then((res: any) => {
      try {
        const blob = new Blob([res.data], {
          type: 'application/pdf',
        });
        if (name) {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = name;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        } else {
          window.location.href = URL.createObjectURL(blob);
        }
      } catch (error) {
      } finally {
        isLoading && isLoading(false);
      }
    })
    .catch(() => {
      isLoading && isLoading(false);
    });
};
export const downloadSelectedPdfApi = (param, data) => {
  const { lang, id, otp } = param;
  return BaseXHR.$post(
    `sunid/v1/deliver-ticket/download/batch/${lang}/${id}/${otp}`,
    data,
    {
      responseType: 'arraybuffer',
    },
  );
};
